import PropTypes from "prop-types";
import { useReducer, useState } from "react";
import { VideoLightbox } from "./VideoLightbox";

interface Props {
  text: string;
  property1: "fill" | "default";
  className: any;
  text1: string;
  videoUrl?: string;
}

export const MediumButton = ({
  text = "WATCH VIDEO",
  property1,
  className,
  text1 = "WATCH VIDEO",
  videoUrl,
}: Props): JSX.Element => {
  const [state, dispatch] = useReducer(reducer, {
    property1: property1 || "default",
  });
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const handleClick = () => {
    if ((text === "WATCH VIDEO" || text1 === "WATCH VIDEO") && videoUrl) {
      setIsVideoOpen(true);
    }
  };

  return (
    <>
      <div
        className={`min-h-[47px] border border-solid border-[var(--fy-grey)] w-56 flex items-center pt-[5.38px] pb-[5.37px] px-px rounded-[100px] justify-center relative transition-all duration-200 ${state.property1 === "fill" ? "bg-[var(--fy-grey)]" : ""} ${className} cursor-pointer`}
        onMouseLeave={() => {
          dispatch("mouse_leave");
        }}
        onMouseEnter={() => {
          dispatch("mouse_enter");
        }}
        onClick={handleClick}
      >
        <div
          className={`font-button-medium tracking-[var(--button-medium-letter-spacing)] [font-style:var(--button-medium-font-style)] text-[length:var(--button-medium-font-size)] flex-1 font-[number:var(--button-medium-font-weight)] text-center leading-[var(--button-medium-line-height)] relative transition-colors duration-200 ${state.property1 === "fill" ? "text-[var(--fy-whiteish)]" : "text-[var(--fy-grey)]"}`}
        >
          {state.property1 === "default" && <>{text1}</>}
          {state.property1 === "fill" && <>{text}</>}
        </div>
      </div>

      {videoUrl && (
        <VideoLightbox
          isOpen={isVideoOpen}
          onClose={() => setIsVideoOpen(false)}
          videoUrl={videoUrl}
        />
      )}
    </>
  );
};

function reducer(state: any, action: any) {
  switch (action) {
    case "mouse_enter":
      return {
        ...state,
        property1: "fill",
      };

    case "mouse_leave":
      return {
        ...state,
        property1: "default",
      };
  }

  return state;
}

MediumButton.propTypes = {
  text: PropTypes.string,
  property1: PropTypes.oneOf(["fill", "default"]),
  text1: PropTypes.string,
  videoUrl: PropTypes.string,
}; 